import { render, staticRenderFns } from "./viewAgentBookings.vue?vue&type=template&id=0fbedf96"
import script from "./viewAgentBookings.vue?vue&type=script&lang=js"
export * from "./viewAgentBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports